<template>
  <nav class="flex h-header">
    <ui-header-nav-item
      v-for="appRoute in visibleRoutes"
      :key="appRoute.title"
      :route="appRoute"
      class="h-full"
      :is-active="activeRoute === appRoute.link"
    />
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { headerNavBarRoutes } from './index';
import { getVisibleRoutes } from '@/common/helpers';

const route = useRoute();

const visibleRoutes = computed(() => getVisibleRoutes(headerNavBarRoutes));

const activeRoute = computed(() => route.path);
</script>
